import React from 'react';

const Testimonials = () => {
  return (
    <section id="depoimentos" className="py-20 bg-primary-black text-primary-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12 mb-16">
          <div className="lg:w-1/3">
            <img 
              src="/images/processed/1000836010_nobg.png" 
              alt="Kelton Oliveira" 
              className="w-full h-auto mx-auto"
            />
          </div>
          
          <div className="lg:w-2/3">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 relative">
              O que dizem sobre este trabalho
              <span className="absolute bottom-0 left-0 w-24 h-1 bg-accent-red mt-2"></span>
            </h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-dark-gray p-6 border-l-2 border-accent-red">
                <p className="italic mb-4 text-gray-300">
                  "O processo terapêutico com Kelton me permitiu finalmente compreender e romper padrões emocionais que me acompanhavam há décadas. Hoje sinto uma liberdade que não imaginava ser possível."
                </p>
                <p className="font-semibold">— Mariana S., 42 anos</p>
              </div>
              
              <div className="bg-dark-gray p-6 border-l-2 border-accent-red">
                <p className="italic mb-4 text-gray-300">
                  "Mais que um terapeuta, encontrei um guia para uma jornada profunda de autoconhecimento. A abordagem humanizada e ao mesmo tempo técnica faz toda diferença nos resultados."
                </p>
                <p className="font-semibold">— Ricardo M., 38 anos</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <p className="text-4xl font-bold text-accent-red">+2 mil</p>
              <p className="text-sm uppercase tracking-wider mt-2">Atendimentos realizados</p>
            </div>
            
            <div className="text-center">
              <p className="text-4xl font-bold text-accent-red">+4 mil</p>
              <p className="text-sm uppercase tracking-wider mt-2">Membros em comunidades</p>
            </div>
            
            <div className="text-center">
              <p className="text-4xl font-bold text-accent-red">+8 Milhões</p>
              <p className="text-sm uppercase tracking-wider mt-2">Views nas redes sociais</p>
            </div>
            
            <div className="text-center">
              <p className="text-4xl font-bold text-accent-red">2º</p>
              <p className="text-sm uppercase tracking-wider mt-2">Segundo livro a caminho...</p>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <div className="inline-block bg-dark-gray px-8 py-4 border-l-2 border-accent-red">
              <p className="text-xl font-medium">Pesquisa científica com relevância em EUA e Europa</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
